import { render, staticRenderFns } from "./ProjectListHeader.vue?vue&type=template&id=7a3e8794&scoped=true&"
import script from "./ProjectListHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListHeader.vue?vue&type=style&index=0&id=7a3e8794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3e8794",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
